export default __webpack_public_path__ + "static/media/ico_share.3e2356e3.svg";